/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both join words without spaces; camelCase starts with a lowercase letter (myVariable), while PascalCase capitalizes the first letter too (MyVariable).`)
};

const es_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos unen palabras sin espacios; camelCase comienza con una letra minúscula (myVariable), mientras que PascalCase capitaliza la primera letra también (MyVariable).`)
};

const de_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide verbinden Wörter ohne Leerzeichen; camelCase beginnt mit einem Kleinbuchstaben (myVariable), während PascalCase den ersten Buchstaben auch kapitalisiert (MyVariable).`)
};

const nl_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide voegen woorden samen zonder spaties; camelCase begint met een kleine letter (myVariable), terwijl PascalCase ook de eerste letter maakt (MyVariable).`)
};

const fr_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux joignent les mots sans espaces ; camelCase commence par une lettre minuscule (myVariable), tandis que PascalCase capitalise aussi la première lettre (MyVariable).`)
};

const it_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambi uniscono le parole senza spazi; camelCase inizia con una lettera minuscola (myVariable), mentre PascalCase capitalizza anche la prima lettera (MyVariable).`)
};

const pt_br2_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos unem palavras sem espaços; camelCase começa com uma letra minúscula (myVariable), enquanto PascalCase capitaliza a primeira letra também (MyVariable).`)
};

const pt_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos unem palavras sem espaços; camelCase começa com uma letra minúscula (minhaVariável), enquanto PascalCase também capitaliza a primeira letra (MinhaVariável).`)
};

const ja_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらもスペースなしで単語を結合します。camelCase は小文字で始まります（myVariable）、一方 PascalCase は最初の文字も大文字化します（MyVariable）。`)
};

const zh_cc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两者都会去掉单词间的空格；camelCase 以小写字母开头（myVariable），而 PascalCase 连第一个字母也大写（MyVariable）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq1_a", locale)
	if (locale === "en") return en_cc_faq1_a(inputs)
	if (locale === "es") return es_cc_faq1_a(inputs)
	if (locale === "de") return de_cc_faq1_a(inputs)
	if (locale === "nl") return nl_cc_faq1_a(inputs)
	if (locale === "fr") return fr_cc_faq1_a(inputs)
	if (locale === "it") return it_cc_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq1_a(inputs)
	if (locale === "pt") return pt_cc_faq1_a(inputs)
	if (locale === "ja") return ja_cc_faq1_a(inputs)
	return zh_cc_faq1_a(inputs)
};